var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M42.5736 127.426C66.0051 150.858 103.995 150.858 127.426 127.426C150.858 103.995 150.858 66.0051 127.426 42.5736C103.995 19.1421 66.0051 19.1421 42.5736 42.5736C19.1422 66.0051 19.1422 103.995 42.5736 127.426Z",
    fill: "#FA756D",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5427 85C64.5427 95.8678 76.2326 109.934 76.2326 109.934C82.4429 117.604 87.5572 117.604 93.7675 109.934C93.7675 109.934 105.457 95.8678 105.457 85C105.457 74.1322 93.7675 60.0665 93.7675 60.0665C87.5572 52.3965 82.4429 52.3965 76.2326 60.0665C76.2326 60.0665 64.5427 74.1322 64.5427 85ZM80.7574 89.2426C83.1005 91.5858 86.8995 91.5858 89.2427 89.2426C91.5858 86.8995 91.5858 83.1005 89.2427 80.7574L89.2384 80.7531C86.8953 78.41 83.0963 78.41 80.7531 80.7531C78.41 83.0963 78.41 86.8953 80.7531 89.2384L80.7574 89.2426Z",
    fill: "#FA756D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompass);
export default __webpack_public_path__ + "static/media/compass.6ff7a5a3513dd58646d14284c06594df.svg";
export { ForwardRef as ReactComponent };